// "YYYY-MM-DD" é data de calendário, sem hora nem fuso. new Date("2026-10-26") a lê como
// meia-noite UTC, que em UTC-3 cai às 21h do dia 25: o dia saía um a menos e "hoje" virava vencido.
// Data só com dia vira meia-noite LOCAL; qualquer outra forma segue como new Date() sempre leu.
export function parseDateOnly(value) {
  const m = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null;
  if (!m) return new Date(value);
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const date = new Date(y, mo - 1, d);
  // Mês/dia fora do calendário ("2026-02-31") continua inválido, como era, em vez de rolar para março.
  return date.getFullYear() === y && date.getMonth() === mo - 1 && date.getDate() === d ? date : new Date(NaN);
}
